import { IncomingEventType } from '@thoughtspot/embed-util';
import { EventType, nonMemoizedEventTypes } from './core/constants';
import {
    destroy,
    dispatchEvent,
    dispatchNonMemoEvent,
    onMessage,
} from './core/handlers';
import {
    createEventSubscriber,
    createMultipleEventSubscriber,
    subscribe,
    subscribeMultiple,
} from './core/subscribe';
import {
    getHostEventConfig,
    getParentOrigin,
    setHostEventConfig,
    setParentOrigin,
} from './core/utils';
import { dispatchValidationError } from './core/validation';
import { initUiPassthroughEvent } from './ui-passthrough-interface';

const init = () => {
    window.addEventListener('message', onMessage);
    initUiPassthroughEvent(IncomingEventType.UiPassthrough, subscribe);
    dispatchNonMemoEvent(EventType.EmbedListenerReady, {});
};

export {
    subscribe,
    subscribeMultiple,
    createEventSubscriber,
    createMultipleEventSubscriber,
    dispatchEvent,
    dispatchNonMemoEvent,
    init,
    destroy,
    getHostEventConfig,
    getParentOrigin,
    setHostEventConfig,
    setParentOrigin,
    nonMemoizedEventTypes,
    dispatchValidationError,
};
